import React, { useEffect, useState } from 'react';

function formatElapsed(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

// Live-updating "how long has this session been active" stopwatch — counts
// UP from the moment of login (`loginAt`, a server-recorded timestamp kept
// deliberately separate from the app JWT's own `iat` — see backend/src/
// lib/loginTime.js for why a token refresh must NOT reset this, only a
// genuinely new login should). Ticks once a second via a local interval;
// never hits the network itself, just re-renders elapsed time against the
// fixed `loginAt` it was given. Used on TopBanner.jsx (the user's own
// session, visible on every page) and AdminUserDetail.jsx (an admin
// viewing someone else's).
export default function SessionTimer({ loginAt, style }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!loginAt) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [loginAt]);

  if (!loginAt) return null;

  return <span style={style}>{formatElapsed(now - loginAt)}</span>;
}
